<ion-header class="header --w-back-button">
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-list class="breadcrumb">
        <ion-item
          *ngFor="let breadcrumb of breadcrumbs"
          class="breadcrumb__item"
          detail="false"
          routerDirection="back"
          [routerLink]="[breadcrumb.link]"
        >
          <span [innerHTML]="breadcrumb.name"></span> <span class="breadcrumb__item__dash">/</span>
        </ion-item>
      </ion-list>
      <ion-back-button [defaultHref]="routes.events" text="" icon="arrow-back-outline"></ion-back-button>
    </ion-buttons>
    <ion-title class="--logo">
      <a class="header__logo" [routerLink]="['/']">
        <app-logo></app-logo>
      </a>
      <span [innerHTML]="'EVENT_DETAIL_PAGE.TITLE' | translate"></span>
    </ion-title>
    <ion-buttons slot="end">
      <ion-avatar class="header__avatar" [routerLink]="['..', routes.settings]">
        <img class="header__avatar__image" src="/assets/avatar/anna.svg" [alt]="(user$ | async)?.firstName" />
      </ion-avatar>
      <ion-menu-button class="header__burger" icon="menu-outline" autoHide="false"></ion-menu-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content class="event" [fullscreen]="true">
  <app-event-detail-component
    *ngIf="event$ | async; let event"
    [event]="event"
    (joinEvent)="joinEvent()"
    (rescheduleCheckup)="rescheduleCheckUp(event)"
  ></app-event-detail-component>
</ion-content>

<ion-footer class="footer">
  <ion-toolbar>
    <ion-buttons slot="end" *ngIf="event$ | async; let event">
      <app-color-select
        *ngIf="(event.contentId | toEventContent | async)?.type !== checkUpType; else rescheduleButton"
        [size]="'big'"
        [event]="event"
        [availablePlaces]="event?.id | getAvailablePlaces | async"
        [presentingElement]="presentingElement"
        [capacity]="(event.contentId | toEventContent | async)?.participationLimit"
      ></app-color-select>
      <ng-template #rescheduleButton>
        <app-reschedule-button [size]="'large'" (clicked)="rescheduleCheckUp(event)"></app-reschedule-button>
      </ng-template>
    </ion-buttons>
  </ion-toolbar>
</ion-footer>
